import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PicklistManager from '@/components/picklist/PicklistManager';
import UoMManager from '@/components/uom/UoMManager';
import ApiKeyManager from '@/components/api/ApiKeyManager';
import ApiDocumentation from '@/components/api/ApiDocumentation';
import StatusWorkflowManager from '@/components/status/StatusWorkflowManager';
import ExternalSystemManager from '@/components/externalsystem/ExternalSystemManager';
import SettingsManager from '@/components/settings/SettingsManager';
export default function Configuration() {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'picklists';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Configuration</h1>
        <p className="text-muted-foreground mt-1">Manage picklists, units of measure, API keys, and application settings</p>
      </div>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="w-full justify-start border-b border-border rounded-none bg-transparent h-auto p-0 mb-6">
          <TabsTrigger value="picklists" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">Picklists</TabsTrigger>
          <TabsTrigger value="uom" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">Unit of Measure</TabsTrigger>
          <TabsTrigger value="status-workflows" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">Status Workflows</TabsTrigger>
          <TabsTrigger value="external-systems" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">External Systems</TabsTrigger>
          <TabsTrigger value="api-keys" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">API Keys</TabsTrigger>
          <TabsTrigger value="api-docs" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">API Documentation</TabsTrigger>
          <TabsTrigger value="settings" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="picklists" className="mt-6">
          <PicklistManager />
        </TabsContent>
        <TabsContent value="uom" className="mt-6">
          <UoMManager />
        </TabsContent>
        <TabsContent value="status-workflows" className="mt-6">
          <StatusWorkflowManager />
        </TabsContent>
        <TabsContent value="external-systems" className="mt-6">
          <ExternalSystemManager />
        </TabsContent>
        <TabsContent value="api-keys" className="mt-6">
          <ApiKeyManager />
        </TabsContent>
        <TabsContent value="api-docs" className="mt-6">
          <ApiDocumentation />
        </TabsContent>
        <TabsContent value="settings" className="mt-6">
          <SettingsManager />
        </TabsContent>
      </Tabs>
    </div>
  );
}
